import api from "../../database";

export const getAuthenticate = async (userName: string, password: string) => {
  const response = await api.post("/user/authenticate", {
    userName,
    password,
  });

  return response.data; // retorna os dados (ex: token)
};

export const getMe = async (token: string) => {
  const response = await api.get("/user/me", {
    headers: {
      "x-access-token": token,
    },
  });

  return response.data;
};
